import { Box, HStack } from '@chakra-ui/react';
import { Text, Heading, Image } from '@chakra-ui/react';

const Title = ({ title, subtitle, image }) =>
(
    <Box h="380px" bg="black">
        <Image boxSize="100%" objectFit="cover" src={`${process.env.PUBLIC_URL}/images/${image}.png`} style={{opacity: 0.2}} />
        <Box mt="-280px" h="380px" px="20px">
        <Heading as="h2" align="center" size="2xl" color="white">{title}</Heading>
        <HStack mt="10px" justifyContent="center">
            <Text fontSize="2xl" color="white">By</Text>
            <Text mt="10px" fontFamily="Dead Stock" fontSize="3xl" color="white">SHAKA</Text>
        </HStack>
        <Text fontSize="xl" mt="20px" align="center" color="white">{subtitle}</Text>
        </Box>
    </Box>
);

export default Title;